import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { RootState } from '../../../store/store';
import { AgeStepForm } from './AgeStepForm';
import { ageSchema } from '../../schema/ageSchema';
import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function AgeStep(): ReactElement {
  const dispatch = useDispatch();
  const { age } = useSelector((state: RootState) => state.steps);

  const formRef = useFormInteractionTracking('how_old');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Let's get started!"
          subHeader=" It takes about 5 minutes to complete this checkup. It's worth your
          time!"
        />
      </GrayCard>

      <CardPadding>
        <CardHeader
          header="How old are you?"
          subHeader="This determines whether you need one type of coverage."
        />

        <Formik
          initialValues={{ age }}
          onSubmit={onSubmit}
          validationSchema={ageSchema}
          enableReinitialize
        >
          <Form ref={formRef}>
            <AgeStepForm />
            <NavigationButtons />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { AgeStep };
